import { jsx as _jsx } from "react/jsx-runtime";
import t from '../../../../../../lib/translate';
var Counter = function (_a) {
    var activePage = _a.activePage, totalPages = _a.totalPages;
    return (_jsx("div", { children: t('table.pagination.page.location', activePage, activePage > totalPages ? '-' : totalPages) }));
};
export default Counter;
